<template>
  <div class="container">
    <header class="jumbotron">
      <!-- <h3>{{ content }}</h3> -->
      <h5>{{ message }}</h5>
      <div v-if="roles.length > 0">
        <h1>{{  this.currentCompetition.name }}</h1>
          <router-link :to="'/competitions'" class="badge badge-success">
            Åpne stevneliste/stevneinfo
          </router-link>
        <h3>Online aktivering</h3>
        <div v-if="!this.currentCompetition.adminApproved" class="bg bg-warning">Aktivering av stevne gjenstår
            <!-- <a class="badge badge-success float-right"
            :href="'/competition/'+selectedCompetition.id+'/activation'">
            Start aktivering - Vipps ({{ this.activation_price }},-)
          </a> -->
          <button type="submit" class="badge badge-success"
            @click="competitionActivation">
              Aktiver stevne - Vipps {{ this.activation_price > 0 ? '('+this.activation_price + ',-)' : '' }}
          </button>
        </div>
        <div v-else class="bg bg-success">Aktivert!</div>
        <ul>

        <li>
          <router-link :to="'/competition/'+selectedCompetition.id+'/activation'" class="badge badge-success">
            Vis status om stevne aktivering
          </router-link>
        </li>
        </ul>
        <div v-if="this.currentCompetition.adminApproved">
          <h3 >Epost verifisering og utsending</h3>
          <ul>
            <li>
              <router-link 
                :to="'/competition/' + selectedCompetition.id + '/mail'" 
                :class="{'badge badge-success': emailVerified, 'badge badge-warning': !emailVerified}" 
                @click.native="validateEmails">
                Epost - verifisering og utsending
              </router-link>
            </li>
            <li v-if="this.currentCompetition.adminApproved">
              <router-link :to="'#'" class="badge badge-secondary disabled" @click.native.prevent>
                TODO - Godkjenn opprop og send epost til deltakerene
              </router-link>
            </li>
          </ul>
        </div>
        <h3>Stevne administratorer  ({{ this.$route.params.competition_id }})</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Nummer</th>
              <th>Navn</th>
              <!-- <th>Rolle</th>
              <th>Detaljer 1</th>
              <th>Detaljer 2</th> -->
              <th>Beskrivelse</th>
              <!-- <th>Arrangør</th>
              <th>Stevne ID</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(role, index) in roles" :key="index">
              <td>{{ role.username }}</td>
              <td>{{ role.vippsuser ? role.vippsuser.name : '' }}</td>
              <!-- <td>{{ role.name }}</td>
              <td>{{ role.details1 }}</td>
              <td>{{ role.details2 }}</td> -->
              <td>{{ role.description }}</td>
              <!-- <td>{{ role.organizer }}</td>
              <td>{{ role.competition_id }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>Ingen competition_admin?</p>
      </div>
      <router-link :to="'/competition/'+selectedCompetition.id+'/admin/add'" class="nav-link">
        <font-awesome-icon icon="user-plus" /> Legg til stevne administrator
      </router-link>
    </header>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import CompetitionDataService from "../services/CompetitionDataService";
import MyComputed from "../myComputed";

export default {
  mixins: [MyComputed],
  name: 'User',
  data() {
    return {
      content: '',
      message: '',
      roles: [],
      activation_price: 0
    };
  },
  mounted() {
    this.getCompetition(this.$route.params.competition_id);
    UserService.getModeratorBoard(this.$route.params.competition_id).then(
      response => {
        console.log("getModeratorBoard - success")
        this.content = response.data;
        this.roles = response.data;
      },
      error => {
        if (error.response.status == 440) {
          if (error.response && error.response.data.message) {
            this.content = error.response.data.message;
            this.message = "(" + error.response.data.timedouttime + ")";
          } else {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
          setTimeout(() => {
            this.logOut();
          }, 3000);
        } else {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      }
    );
  },
  methods: {
    getCompetition(id) {
      CompetitionDataService.get(id)
        .then(response => {
          this.currentCompetition = response.data[0];
        })
        .catch(e => {
          console.log(e);
        });
    },
    competitionActivation() {
      console.log("competitionActivation");
      console.log(this.$route.params.competition_id);
      CompetitionDataService.competitionActivation(this.$route.params.competition_id)
    },
    showCompetitionActivation() {
      console.log("showCompetitionActivation");
      // Change route to /competition/:competition_id/activation
      this.$router.push({ name: 'competitionActivation', params: { competition_id: this.$route.params.competition_id } });
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>
